import { render, staticRenderFns } from "./studyRecords.vue?vue&type=template&id=48c95f54&scoped=true"
import script from "./studyRecords.vue?vue&type=script&lang=js"
export * from "./studyRecords.vue?vue&type=script&lang=js"
import style0 from "./studyRecords.vue?vue&type=style&index=0&id=48c95f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c95f54",
  null
  
)

export default component.exports